import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
const apiUrl = process.env.REACT_APP_API_URL;

function UserAuditDetail() {
  const [logs, setLogs] = useState([]);
  const [userName, setUserName] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [itemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);

  const { userId } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const page = parseInt(searchParams.get("page")) || 1;
    setCurrentPage(page);
    fetchAuditLogs(page);
  }, [userId, searchParams]);

  const fetchAuditLogs = async (page = 1) => {
    try {
      setLoading(true);
      const token = localStorage.getItem("accessToken");
      if (!token) {
        navigate("/");
        return;
      }
      const response = await fetch(
        `${apiUrl}fetch-user-audit-logs/${userId}?page=${page}&limit=${itemsPerPage}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const result = await response.json();

      const auditLogs = result.data?.logs || [];
      const totalCount = result.data?.totalCount || 0;

      if (auditLogs.length > 0 && !userName) {
        setUserName(auditLogs[0].username);
      }

      setLogs(auditLogs);
      setTotalPages(Math.ceil(totalCount / itemsPerPage));
    } catch (error) {
      console.error("Error fetching audit logs:", error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const handlePageChange = (newPage) => {
    navigate(`?page=${newPage}`);
  };

  const renderPagination = () => {
    return (
      <div className="d-flex justify-content-between align-items-center mt-4">
        <button
          className="btn btn-outline-secondary px-4 rounded"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Previous
        </button>

        <div className="text-center">
          Page {currentPage} of {totalPages}
        </div>

        <button
          className="btn btn-outline-secondary px-4 rounded"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    );
  };

  return (
    <>
      <div className="dashboard-title mb-3">
        <h1>
          <a
            href="/view-user-audit"
            className="btn btn-outline-secondary btn-sm me-3"
          >
            <i className="bi bi-arrow-left"></i>
          </a>
          {userName} Audit Detail
        </h1>
      </div>
      <div className="row mb-3">
        <div className="col-12 col-xl-12">
          <div className="table-container">
            {loading ? (
              <div className="text-center p-4">Loading...</div>
            ) : (
              <>
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Time</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {logs.map((log, index) => (
                      <tr key={log.id}>
                        <th scope="row">
                          {(currentPage - 1) * itemsPerPage + index + 1}
                        </th>
                        <td>{formatDate(log.createdAt)}</td>
                        <td>{log.action}</td>
                      </tr>
                    ))}
                    {logs.length === 0 && (
                      <tr>
                        <td colSpan="3" className="text-center">
                          No audit logs found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                {logs.length > 0 && renderPagination()}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default UserAuditDetail;
